import React, { useContext, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  useTheme,
} from "@mui/material";
import { useMutation } from "@apollo/client";
import { CREATE_POLESET, POLESETS } from "../graphql/gqlPoleset";
import { useParams } from "react-router-dom";
import { SnackbarContext } from "../contexts/snackbarContext";
import { T } from "../components/T";

const CreateNewPolesetModal = ({
  isOpen,
  close,
}: {
  isOpen: boolean;
  close: () => void;
}) => {
  const { userId } = useParams();
  const theme = useTheme();

  const [newPolesetName, setNewPolesetName] = useState("");
  const { openSuccessSnackbar, openErrorSnackbar } =
    useContext(SnackbarContext);

  const [createPoleset] = useMutation(CREATE_POLESET, {
    onCompleted: () => {
      close();
      setNewPolesetName("");
      openSuccessSnackbar(<T str="Poleset created" />);
    },
    onError: (error) => {
      openErrorSnackbar(error.message || <T str="Failed to create poleset" />);
    },
    refetchQueries: [
      {
        query: POLESETS,
        variables: { userId },
      },
    ],
  });

  const handleCreatePoleset = () => {
    createPoleset({
      variables: {
        name: newPolesetName,
      },
    });
  };

  return (
    <Dialog
      open={isOpen}
      onClose={close}
      PaperProps={{
        sx: {
          bgcolor: theme.palette.background.paper,
          color: theme.palette.text.primary,
        },
      }}
    >
      <DialogTitle>
        <T str="Create new poleset" />
      </DialogTitle>
      <DialogContent>
        <TextField
          label={<T str="Poleset name" />}
          value={newPolesetName}
          onChange={(e) => setNewPolesetName(e.target.value)}
          fullWidth
          color="secondary"
          required
          sx={{
            mb: 2,
            mt: 2,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={close}>
          <T str="Cancel" />
        </Button>
        <Button
          onClick={handleCreatePoleset}
          variant="contained"
          color="secondary"
          disabled={!newPolesetName}
        >
          <T str="Create" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateNewPolesetModal;
